"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GroupSessions", {
  enumerable: true,
  get: function get() {
    return _GroupSessions.default;
  }
});
var _GroupSessions = _interopRequireDefault(require("./GroupSessions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }